import { featured } from "@/pages/home/content";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  headline: "从“网传”到“实锤”，一场吃瓜的全流程观察",
  description: featured.lead,
  inLanguage: "zh-CN",
  publisher: { "@type": "Organization", name: "大瓜预警" },
};

export default function Featured() {
  return (
    <section
      id="featured"
      className="w-full bg-background-100 py-12 md:py-16"
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="relative min-h-[260px] w-full overflow-hidden rounded-2xl border border-background-200">
            <img
              src={featured.image}
              alt="从网传到实锤的吃瓜流程专题"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-star-fill text-sm" />
              编辑部精选
            </span>
          </div>

          <div className="flex flex-col justify-center">
            <p className="text-xs font-semibold tracking-[0.3em] text-accent-700">
              {featured.kicker}
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {featured.title}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              {featured.lead}
            </p>
            <ul className="mt-5 space-y-3">
              {featured.points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm text-foreground-800">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-800">
                    <i className="ri-check-line text-xs" />
                  </span>
                  <span className="leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>
            <a
              href="#latest"
              className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              去热瓜列表看案例
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}